// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import api from '../../../common/api';
import config from '../../../share/config';
import handler from '../../../share/util/apiResultValidator';
import cstmTable from '../../../share/components/vue/PaginationTable';
import resource from '../../../share/util/resourceMap';
import util from '../../../share/util/utils';
import diag from '../../../share/util/diagnose';
import alert from '../../../share/alert';
import vehicle from '../../../share/util/vehicle';
import loading from '../../../share/components/vue/ProcessingIcon';
import customProgress from "../../../share/components/vue/CustomProgress";
import cstmPaging from '../../../share/components/vue/Pagination';
import memoPage from '../../vue/MemoPage';
import printModal from '../../vue/DiagPrintModal';
import ffdModal from '../../vue/FFDModal';
import diagnoResource from '../../../share/util/diagnose';
import logWrapper from '../../../share/logWrapper';
import individualDiagnose from '../../../share/util/individualDiagnose';
import error from '../../../common/nodejs/errors';
import eventLogUtil from '../../../share/util/eventLogUtil';
import constants from '../../../common/nodejs/constants';
import inputValidator from '../../../share/util/inputValidator';
import apiService from '../../../share/util/api/service';
import { getMeasuredDataName, getCsvFileName } from '../../../util/fileExport';

// 車両アクセス状態
const VEHICLE_INFO_GET = "get";
const VEHICLE_MEMORY_CLEAR = "clear";

const CHAIN_DTC_MAP = [
  { type: 'normal', label: 'message.button_vehicle_dtc_chain_dtc_normal' },
  { type: 'all', label: 'message.button_vehicle_dtc_chain_dtc_all' }
];

/** ボタンのクラス名 */
const buttonFontSizeOther = "dtc-table-button-font-size-other";

export default {
  name: "dtcTable",
  data() {
    return {
      processing: false,
      dtcSystemTableColumns: [],
      dtcListItems: [],
      phaseMessage: '',
      vehicleRunStatus: null,
      // FFD一覧
      ffdTitle: '',
      ffdSystem: '',
      ffdDescription: '',
      ffdDetailTableColumns: [],
      ffdListBuff: [],
      ffdSystemTable: [],
      selectedSystem: null,
      // DTC削除
      deletePhase: '',
      testModeVisible: false,
      chainDtcType: 'normal',

      // ダイアログフラグ
      modalFfd: false,
      modalFormPrint: false,
      modalMemo: false,
      modalVehicle: false,
      modalDelete: false,
      modalAlertCgwCecuNotCommunicated: false,
      isMemoDialogLoading: false,

      // テストモード時のメモ情報保持変数
      memoData: {
        diagnoseComment: null,
        dataName: "data1",
        memo: null
      },

      // 帳票印刷
      modalSettingMileageForm: false,
      isPrintFormatButtonDisable: true,
      inputMileage: '',
      isAlert: {
        data: { valid: null, msg: '' }
      },
      printUserInfo: {},
    };
  },

  watch: {
    language: {
      immediate: true,
      handler(val) {
        val; // To avoid warning
        // ALLDTC情報・カラムを作り直す
        this.updateDTCTable();
        this.updateColumns();
      }
    },

    dtcTableData(tbl) {
      if (!tbl) return;
      this.dtcListItems = tbl;
    },

    // 車両情報取得(診断)の状態監視 
    async vehicleStatus(value) {
      // 失敗
      if (value === config.POLLING_FAILURE) {
        this.vehicleRunStatus = null;
        // 車両情報取得のwait画面を終了
        this.modalVehicle = false;
        const error = this.vehicleError;
        // VINの状態が全取得時と異なっていた場合、警告ダイアログ表示
        if (error.validatorResult?.causeType === handler.causeTypes.differentVinError) {
          // 車両情報取得処理停止 
          this.$stopInterval(this.vehicleWatcher);
          // 取得した情報のVIN番号が異なる場合 
          const messages = this.$t(error.message);
          alert.showWarning(this, null, messages, () => {
            // 車両情報が異なるためエラーとして start 画面に戻す 
            this.$router.push({ name: 'home', params: { isAuto: true, isConfirmSkip: true } });
            return;
          });
          return;
        }
        // APIバリデータの戻りを確認
        if (error.validatorResult) {
          // ネットワーク接続エラーとセッション情報エラーは警告メッセージで表示する
          if (error.validatorResult.causeType === handler.causeTypes.networkError ||
            error.validatorResult.causeType === handler.causeTypes.invalidSessionToken) {
            alert.showWarning(this, null, error.message, () => {
              if (error.behaviorType === handler.behaviorTypes.logout) {
                this.logout(this);
              }
              else if (error.behaviorType === handler.behaviorTypes.resetSession) {
                this.resetSession(this);
              }
            });
            return;
          }
          // 警告以外のエラーメッセージの表示
          this.showFailedMessage('message.error_vehicle_connect_title', this.vehicleError);
        }
        else {
          // バリデータ情報がない場合はエラーメッセージを表示する
          this.showFailedMessage('message.error_vehicle_connect_title', this.vehicleError);
        }
      }
      // 成功
      else if (value === config.POLLING_COMPLETED) {
        const projectInfo = {
          projectId: this.vehicleInfo.vehicle.project.id,
          measureId: this.vehicleInfo.vehicle.project.all_dtc.measure_id,
          operationScreen: this.operationScreen
        };

        if (projectInfo.projectId === null || projectInfo.measureId === null) {
          alert.showError(this, null, this.$t('message.error_vehicle_connect_title'));
          return;
        }

        // 個別診断機能が利用可能な場合のみ個別診断メニュー一覧を取得する
        if (this.isIndividualDiagAvailable) {
          const individualMenuInfo = {
            netAppId: this.pairingAppId,
            modal: this
          };
          const individualMenuData = await this.getIndividualMenus(individualMenuInfo);
          if (individualMenuData.errorResult) {
            if (individualMenuData.errorResult.causeType === handler.causeTypes.permissionError) {
              // ユーザー権限エラーの場合、エラーダイアログを表示しログアウトする
              alert.showError(this, null, individualMenuData.errorResult.message, () => {
                this.logout(this);
              });
            } else if (individualMenuData.errorResult.behaviorType === handler.behaviorTypes.logout) {
              this.logout(this);
            }
            else {
              // 予期せぬエラーで個別診断Menuが取得出来なかった際の処理
              alert.showError(this, null, this.$t('message.error_vehicle_connect_title'));
            }
            return;
          }
        }

        const dtcTableResponse = await this.getDtcSystemTable(projectInfo);
        if (dtcTableResponse.errorResult) {
          // ユーザー権限エラーの場合はエラーダイアログを表示
          if (dtcTableResponse.errorResult.causeType === handler.causeTypes.permissionError) {
            alert.showError(this, null, this.$t(api.getErrorMessageForCode(error.USER_ACCESS_PERMISSION_ERROR)),
              () => { this.logout(this); }
            );
          }
          else if (dtcTableResponse.errorResult.behaviorType === handler.behaviorTypes.logout) {
            this.logout(this);
          }
          else {
            // DTCテーブル情報を取得出来た場合、情報を保持
            // 予期せぬエラーでallDtcSystemが取得出来なかった際の処理
            alert.showError(this, null, this.$t('message.error_vehicle_connect_title'));
          }
          return;
        }
        if (this.vehicleRunStatus === VEHICLE_INFO_GET) {
          // テーブル情報の更新
          this.updateDTCTable();
          this.setProgress(100);
          await util.sleep(1000);
          // 車両情報取得のwait画面を終了
          this.modalVehicle = false;

          // 取得した情報のVIN番号が異なる場合 
          if (this.vehicleInfo.vehicle.is_vin_changed === true) {
            const messages = this.$t('message.message_change_vehicle_info_error');
            alert.showWarning(this, null, messages, () => {
              // 車両情報が異なるためエラーとして start 画面に戻す 
              this.$router.push({ name: 'home', params: { isAuto: true, isConfirmSkip: true } });
              return;
            });
          } else {
            // テーブル情報の更新
            this.updateDTCTable();
            // DTCcolumnテーブルの更新
            this.updateColumns();
            // 診断情報取得のカウントを１つアップする。 
            this.usageCountUp({ type: config.USAGE_COUNT_DIAG });
          }
        } else if (this.vehicleRunStatus === VEHICLE_MEMORY_CLEAR) {
          // メモリクリアの結果画面の表示
          this.resultMemoryClear();
        }
        this.vehicleRunStatus = null;
      }
    },

    // メモリクリアの削除カウントの監視
    systemCount(value) {
      // value が null の場合、処理しない
      if (!value) {
        return;
      }
      let completedConut = value.completedConut;
      let allConut = value.allConut;
      if (!value.completedConut || !value.allConut) {
        // メモリクリアする個数を表示する。完了した件数は０で固定値で持つ
        completedConut = '0';
        allConut = this.allDtcSystems.clear_dtc_all_system_count === -1 ? ' - ' : this.allDtcSystems.clear_dtc_all_system_count;
      }
      const deleteMessage = this.$t('message.message_vehicle_dtc_removin') + ' ' + completedConut + '/' + allConut + this.$t('message.label_vehicle_dtc_removing_item');
      this.deletePhase = deleteMessage;
    },

    // 車両情報取得(診断)ステータス状態監視 
    async phase(value) {
      // ステータスに応じた文言を設定
      this.phaseMessage = vehicle.getPhaseResources(value, this.phaseMessage, this.apiDestination, config.INQUIRY_TYPE_DTC);
      // VIN情報・車台番号が取得できない場合 
      if (value === config.COMMUNICATION_UI_VIN_REQUIRED) {
        // 車両番号が同一の場合は入力画面を表示せず、VIN 更新
        if (this.oldVehicleInfo) {
          if (this.vehicleInfo.vehicle.vin.vin === this.oldVehicleInfo.vehicle.vin.vin) {
            // 本APIの失敗はvehicleStatusに格納される 
            await this.runSystemApi({ netAppId: this.pairingAppId, this: this, type: config.DIAG });
          } else {
            // 車両情報取得処理停止 
            this.$stopInterval(this.vehicleWatcher);
            // 車両情報取得のwait画面を終了
            this.modalVehicle = false;
            // 取得した情報のVIN番号が異なる場合 
            const messages = this.$t('message.message_change_vehicle_info_error');
            alert.showWarning(this, null, messages, () => {
              // 車両情報が異なるためエラーとして start 画面に戻す 
              this.$router.push({ name: 'home', params: { isAuto: true, isConfirmSkip: true } });
              return;
            });
          }
        }
      } else if (value === config.COMMUNICATION_UI_CGW_CECU_NOT_COMMUNICATED) {
        // CGW/C-ECU通信無しの場合
        this.modalVehicle = false;
        this.modalAlertCgwCecuNotCommunicated = true;
      } else if (value === config.COMMUNICATION_UI_CONFIRM_READ_LEGISLATED_SUPPORT_IDS) {
        // リアルワールドデータ手動取得の場合
        // 全DTCの場合は、確認ダイアログを出さず、is_consent_obfcm: false(OBFCM取得しない) でAPI実行のみ行う
        await this.getObfcmToVehicle();
      }
    }

  },

  components: {
    'processing-view': loading,
    'cstm-table': cstmTable,
    'custom-Progress': customProgress,
    'memo-Page': memoPage,
    'cstm-paging': cstmPaging,
    'print-modal': printModal,
    'ffd-modal': ffdModal
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),
    ...mapActions('userProperty', ['setUserCache']),
    ...mapActions('vehicle', ['updateVehicleInfo', 'runSystemApi', 'deleteMemoryClear', 'setProgress', 'getIndividualMenus', 'continueSystemApi']),
    ...mapActions('table', ['getDtcSystemTable']),
    ...mapActions('observation', ['usageCountUp']),
    ...mapActions('cache', ['cacheFFDStores']),

    // 帳票印刷画面の表示
    openPrintModal: function () {
      // ユーザー情報登録
      this.printUserInfo = {
        name: this.userInfo.userName,
        language: this.language,
        region: this.userInfo.region
      };
      this.modalFormPrint = true;
    },
    // 帳票印刷を実行
    startPrint() {
      this.$refs.print_modal.print();
    },

    // メモダイアログを表示
    openNoteModal() {
      this.modalMemo = true;

      // テストモード用のメモ情報設定
      if (this.isTestMode) {
        this.$nextTick(() => {
          this.$refs.memo.diagnoseComment = this.memoData.diagnoseComment;
          this.$refs.memo.dataName = this.memoData.dataName;
          this.$refs.memo.memo = this.memoData.memo;
        });
      }
    },

    // メモダイアログを非表示
    closeNoteModal() {
      this.modalMemo = false;
    },
    // メモ情報の保存
    async memoSave() {
      // テストモード用のメモ情報設定
      if (this.isTestMode) {
        this.processing = true;
        this.memoData.diagnoseComment = this.$refs.memo.diagnoseComment;
        this.memoData.dataName = this.$refs.memo.dataName;
        this.memoData.memo = this.$refs.memo.memo;
        await util.sleep(1000);
        this.processing = false;
      }

      await this.$refs.memo.save();
    },
    // メモ情報のクリア
    memoClear: function () {
      this.$refs.memo.clear();
    },


    getRequestBody: function () {
      return {
        project: {
          name: this.projectID,
          comment: this.diagnoseComment,
          measured: {
            name: this.dataName,
            memo: this.memo
          }
        }
      };
    },

    /**
     * 行をクリックした際の処理を行う
     * @param {object} selected クリックされた行
     */
    clickRow(selected) {
      // 共通メニューサポートのダイアグコード有りの場合遷移する
      if (this.isDisplayIndividualDiagCode(selected.systemID)) {
        // 行がクリックされたことを親に通知
        this.$emit('selectDtcTableRow', selected);
      }
    },

    async clickFFD(data) {
      if (!data) return;
      // タイトルの設定
      const status = data.status ? ` (${this.$t(data.status)}) ` : '';
      let unitResponse = null;
      this.ffdTitle = data.dtc + status;
      this.ffdSystem = this.$t(data.name);
      this.ffdDescription = this.$t(data.description);

      // テストモードの場合はユーザー設定の単位取得
      if (this.isTestMode) {
        this.processing = true;
        unitResponse = await api.getCall(config.ADMIN, '/unitSettings');
        this.processing = false;
        // APIレスポンスの検証
        handler.validate(handler.validateTypes.all, unitResponse, this, null, () => {
        },
          (result) => {
            // 処理が失敗したときのコールバック処理
            if (result.behaviorType === handler.behaviorTypes.logout) {
              this.logout(this);
            }
          });
      }
      const cache = this.cachedFFDs.filter(e => e.system === data.systemID && e.dtc === data.dtc);
      if (cache.length > 0) {
        // キャッシュ有りならキャッシュ済みデータを表示
        this.ffdSystemTable = cache[0].data;
        this.selectedSystem = data;
        if (this.isTestMode) {
          diag.checkUnit(unitResponse, this.ffdSystemTable, this);
        }
        this.modalFfd = true;
      } else {
        // キャッシュなしなら FFD 一覧情報を取得
        const prj = this.vehicleInfo.vehicle.project;
        // 選択された任意のシステムのFFD一覧情報を取得
        const endPoint = '/diagDtc/' + prj.id + '/' + prj.all_dtc.measure_id + '/ffd/' + data.systemID + '/' + data.dtc;
        this.processing = true;
        const res = await api.getCall(config.DIAG, endPoint, this.operationScreen);
        this.processing = false;
        handler.validate(handler.validateTypes.all, res, this, null, () => {
          // FFDダイアログの表示
          this.ffdSystemTable = res.data.data;
          this.cacheFFDStores([...this.cachedFFDs, { system: data.systemID, dtc: data.dtc, data: res.data.data }]);
          this.selectedSystem = data;
          if (this.isTestMode) {
            diag.checkUnit(unitResponse, this.ffdSystemTable, this);
          }
          this.modalFfd = true;
        }, (result) => {
          // 処理が失敗したときのコールバック処理
          if (result.behaviorType === handler.behaviorTypes.logout) this.logout(this);
        });
      }
    },

    // カラムを作り直す
    updateColumns: function () {
      // allDtcSystemsが空の場合、return
      if (!this.allDtcSystems) {
        return;
      }
      const igonCntVar = util.mkHeaderValue(this.allDtcSystems.cgw_igon_time);
      const igonCnt = this.$t('message.header_vehicle_dtc_table_igon_counts');
      const igonCounterValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igonCntVar;
      const igonTimeVar = util.mkHeaderValue(this.allDtcSystems.cgw_igon_mill_sec);
      const igonTime = this.$t('message.header_vehicle_dtc_table_igon_times');
      const igonTimeValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igonTimeVar;
      this.dtcSystemTableColumns = [
        { name: 'name', label: 'message.header_vehicle_table_system_name', useResource: true },
        { name: 'status', label: 'message.header_vehicle_dtc_table_status', useResource: true },
        { name: 'dtc', label: 'message.header_vehicle_dtc_table_code', originalSortFunc: diagnoResource.sortFuncCode },
        { name: 'description', label: 'message.header_vehicle_dtc_table_description', useResource: true, originalSortFunc: diagnoResource.sortFuncDescription },
        { name: 'igonCount', label: util.setColums(igonCnt, igonCounterValue, "{0} {1}", true), useHtmlBind: true, originalSortFunc: diagnoResource.sortIgon },
        { name: 'igonTime', label: util.setColums(igonTime, igonTimeValue, "{0} {1}", true), useHtmlBind: true, originalSortFunc: diagnoResource.sortIgon },
        { name: 'counterType', label: 'message.header_vehicle_dtc_table_type' },
        { name: 'ffd', label: 'message.header_vehicle_dtc_table_ffd', useButton: true, useResource: true, originalSortFunc: diagnoResource.sortFuncFfd },
      ];
    },

    // テーブル情報更新処理
    updateDTCTable: function () {
      // allDtcSystemsが空の場合、return
      if (!this.allDtcSystems) {
        return;
      }
      let dtcListItems = [];
      // DTC情報をシステムIDでグループ化
      const groupBySystem = Object.keys(util.groupBy(this.allDtcSystems.data, 'system'));
      for (const diagSystem of groupBySystem) {
        // DTC情報をシステムIDでフィルター且つ、連鎖DTCでフィルター
        const filteredDtcSystems = this.allDtcSystems.data
          .filter(dtc => dtc.system === diagSystem)
          .filter(dtc => this.chainDtcType === 'all' || !dtc.is_chain_dtc);

        // 個別メニューサポートのダイアグコード判定が true 以外の場合、カーソルをデフォルトで表示する
        const isDefaultCss = !this.isDisplayIndividualDiagCode(diagSystem);

        // フィルターしたDTC情報から、テーブルを作成する
        const targetDtcList = resource.createDtcTable(filteredDtcSystems, diagSystem, this, isDefaultCss);
        dtcListItems = dtcListItems.concat(targetDtcList);
      }
      // ALL DTCテーブル作成
      this.dtcListItems = dtcListItems;
    },

    // 車両情報の再取得
    updateDTC: async function () {
      const messages = this.$t('message.message_vehicle_dtc_confirm_get_information');
      alert.showConfirmation(this, null,
        messages,
        async () => {
          // 車種情報の全取得 
          this.modalVehicle = true;
          const data = {
            netAppId: this.pairingAppId,
            endPoint: '',
            execType: config.INQUIRY_TYPE_DTC,
            this: this,
            // isCreateProject: システムAPI実施前にプロジェクト作成APIを投げるか否かのフラグ
            options: { isCreateProject: false },
            type: config.DIAG
          };
          this.vehicleRunStatus = VEHICLE_INFO_GET;
          this.cacheFFDStores([]);
          this.updateVehicleInfo(data);
        });
    },

    // ダイアグコード削除
    deleteDTC() {
      // メモリクリアを実施できるシステムが１つも存在しなかった場合ダイアログ表示
      if (this.allDtcSystems.clear_dtc_all_system_count === 0) {
        const messages = this.$t('message.message_vehicle_no_clear_dtc');
        alert.showInfo(this, null, messages);
        return;
      }
      // 強調文言
      const sentence = '<span style="color: red; font-size: 16px;">' + this.$t('message.message_vehicle_dtc_confirm_remove_dtc_operation') + '</span>';
      // DTC削除対象のシステム名
      const deleteDiagSystems = this.$t('diagSytem.EGI') + '/' + this.$t('diagSytem.EPS') + '/' + this.$t('diagSytem.ES');
      const messages = this.$t('message.message_vehicle_dtc_confirm_remove_dtc', [sentence, deleteDiagSystems]);
      alert.showConfirmation(this, null, messages,
        async () => {
          const data = {
            netAppId: this.pairingAppId,
            this: this,
            operationScreen: this.operationScreen
          };
          this.vehicleRunStatus = VEHICLE_MEMORY_CLEAR;
          this.cacheFFDStores([]);
          // イベントログの操作 ID 発行
          try {
            this.processing = true;
            await eventLogUtil.createEventLogHandleId(this.pairingAppId);
          } finally {
            this.processing = false;
          }
          // ダイアログ表示
          this.modalDelete = true;
          /* deleteMemoryClear 処理では以下理由で await しない
          ・関数の戻りでエラーなどを取得していない
          ・メモリクリアの状態(エラーも含めて)は watch で状態を監視しているため、本関数はawaitせずすぐ抜けるようにしている */
          this.deleteMemoryClear(data);
        });
    },

    // ダイアグ削除の結果画面の表示
    resultMemoryClear() {
      this.modalDelete = false;
      const failureClearSystems = [];
      let systemName = '';
      util.deepSearch(this.deleteResultDtcs.results, 'is_clear_dtc_success', (key, val) => val === false, failureClearSystems);
      if (failureClearSystems) {
        failureClearSystems.forEach((arg) => {
          systemName += this.$t('diagSytem.' + arg.system_name) + '/';
        });
      }
      let messages = null;
      const removeHeader = this.$t('message.message_vehicle_dtc_complete_remove_dtc_header');
      const removeOperation = '<span style="color: red; font-size: 16px;">' + this.$t('message.message_vehicle_dtc_complete_remove_dtc_operation') + '</span>';
      const removeFooter = this.$t('message.message_vehicle_dtc_complete_remove_dtc_footer');
      if (failureClearSystems.length > 0) {
        const slashSystemName = systemName.slice(0, -1);
        const removeFailure = this.$t('message.message_vehicle_dtc_complete_remove_dtc_failure', [slashSystemName]);
        messages = ('{0}\r\n\r\n{1}\r\n\r\n{2}\r\n\r\n{3}').format(removeHeader, removeFailure, removeOperation, removeFooter);
      }
      else {
        messages = ('{0}\r\n\r\n{1}\r\n\r\n{2}').format(removeHeader, removeOperation, removeFooter);
      }
      alert.showInfo(this, null,
        messages,
        async () => {
          // 車種情報の全取得 
          this.modalVehicle = true;
          const data = {
            netAppId: this.pairingAppId,
            endPoint: '',
            execType: config.INQUIRY_TYPE_DTC,
            this: this,
            // isCreateProject: システムAPI実施前にプロジェクト作成APIを投げるか否かのフラグ
            options: { isCreateProject: false },
            type: config.DIAG
          };
          this.vehicleRunStatus = VEHICLE_INFO_GET;
          this.updateVehicleInfo(data);
        });
    },

    // エラーメッセージ表示処理 
    showFailedMessage(errTitleId, errorInfo, isLogout = true) {
      const error = errorInfo;
      // メンテナンスエラーの場合はエラー表示を変更する 
      let messages = null;
      if (!error.validatorResult || error.validatorResult.causeType === handler.causeTypes.maintenanceError) {
        messages = error.message;
      }
      else {
        const errTitle = this.$t(errTitleId);
        messages = {
          mainMessage: errTitle,
          messageList: []
        };
        const messageFirst = {
          label: this.$t('message.common_label_error_message'),
          message: error.message
        };
        messages.messageList.push(messageFirst);
      }

      alert.showError(this, null, messages, () => {
        if (error.behaviorType === handler.behaviorTypes.logout) {
          if (isLogout) {
            this.logout(this);
          }
        }
        this.modalDelete = false;
      });
    },

    /**
     * 選択された連鎖DTCの状態に応じたボタンラベルを返す
     * @returns i18n用文字列
     */
    getChainDtcButtonLabel() {
      return CHAIN_DTC_MAP.find(elem => elem.type !== this.chainDtcType).label;
    },

    /**
     * 選択された連鎖DTCの状態に応じてテーブルを更新
     */
    switchChainDtc() {
      // トグルボタンの切り替え
      if (this.chainDtcType === 'normal') {
        this.chainDtcType = 'all';
      } else {
        this.chainDtcType = 'normal';
      }
      this.updateDTCTable();
    },

    /**
     * 共通メニューサポートのダイアグコードの判定を取得する
     * @param {string} systemId 対象システム
     * @returns {boolean} ダイアグコードあり
     */
    isDisplayIndividualDiagCode(systemId) {
      // 個別メニューサポートの取得
      const menuList = this.individualMenus && this.individualMenus.menu_list ? this.individualMenus.menu_list : [];
      const targetMenu = menuList.find((menu) => menu.system_name === systemId);
      // 共通メニューサポートのダイアグコードの判定
      return !!(targetMenu && targetMenu.menu_display_config && targetMenu.menu_display_config.diag_code);
    },

    /**
     * 全DTC情報をCSVエクスポートする
     */
    async csvExport() {
      const fileInfo = {};
      let resultInfo = {};
      // 行のフォーマット
      resultInfo = this.dtcListItems.map(item => {
        return {
          ...item,
          name: this.$t(item.name),
          status: this.$t(item.status),
          description: this.$t(item.description),
          ffd: item.buttonVisible ? this.$t('message.available_ffd') : this.$t('message.no_ffd')
        };
      });

      // 列のフォーマット
      const igOnCntVar = util.mkHeaderValue(this.allDtcSystems.cgw_igon_time);
      const igOnCnt = this.$t('message.header_vehicle_dtc_table_igon_counts');
      const igOnCounterValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igOnCntVar;
      const igOnTimeVar = util.mkHeaderValue(this.allDtcSystems.cgw_igon_mill_sec);
      const igOnTime = this.$t('message.header_vehicle_dtc_table_igon_times');
      const igOnTimeValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igOnTimeVar;

      fileInfo.column = this.dtcSystemTableColumns.map(column => {
        if (column.name === 'igonCount') {
          column.label = igOnCnt + " " + igOnCounterValue;
        } else if (column.name === 'igonTime') {
          column.label = igOnTime + " " + igOnTimeValue;
        }
        return column;
      });

      // VINデータのフォーマット
      const vinHeader = `"${this.$t('message.label_measured_data_search_vin')}","${this.vehicleInfo.vehicle.vin.vin}"\n`;

      // 出力形式の設定
      const headers = fileInfo.column.map(column => {
        if (column.name === 'igonCount' || column.name === 'igonTime') {
          return { id: column.name, title: column.label };
        } else {
          return { id: column.name, title: this.$t(column.label) };
        }
      });

      // 説明・故障部位のエスケープ処理
      fileInfo.record = util.escapeDoubleQuotation(resultInfo, 'description');

      let endPoint = '';
      // トレーニングモードは保持しているデータ名を使用
      let measuredDataName = this.isTestMode ? this.testModeMeasuredDataName : '';

      if (!this.isTestMode && this.vehicleInfo.vehicle.project.id !== null && this.vehicleInfo.vehicle.project.all_dtc.measure_id !== null) {
        try {
          this.processing = true;
          // プロジェクトIDおよび計測データIDが存在する場合、計測データ取得APIを指定
          endPoint = '/projects/' + this.vehicleInfo.vehicle.project.id + '/' + this.vehicleInfo.vehicle.project.all_dtc.measure_id;
          // 計測データ名を取得
          measuredDataName = await getMeasuredDataName(this, this.destinationAPI, endPoint, this.operationScreen);
        } finally {
          this.processing = false;
        }
      }
      const fileName = getCsvFileName(this.$t('message.label_measured_data_details_all_dtc'), measuredDataName, this.vehicleInfo.vehicle.vin.vin);

      // CSVファイルエクスポート処理
      const data = vinHeader + util.createCsvData(headers, fileInfo.record);

      // CSVファイルエクスポート処理
      util.csvFileExport(data, fileName);
    },

    /**
     * CGW/C-ECU通信無し警告ダイアログからの車両通信ポーリングの再開処理
     */
    async restartConnectionToVehicle() {
      const data = {
        this: this,
        netAppId: this.pairingAppId,
        requestBody: {
          type: constants.VEHICLE_CONTINUE_CHECK_SYSTEM_TYPE_CGW_CECU_NOT_COMMUNICATED
        }
      };
      this.processing = true;
      // SystemsAPIのCGWサポートチェック後の処理を実行
      const isSuccess = await this.continueSystemApi(data);
      this.processing = false;

      // 正常終了か確認
      if (isSuccess) {
        // CGW/C-ECU通信無し警告ダイアログを閉じて車両通信ポーリングを再開
        this.modalAlertCgwCecuNotCommunicated = false;
        this.modalVehicle = true;
        this.$resumeInterval(this.vehicleWatcher);
      }
      else {
        // ポーリングの停止
        this.$stopInterval(this.vehicleWatcher);
      }
    },

    /**
     * CGW/C-ECU通信無し警告ダイアログのキャンセルイベント
     */
    closeCGwNotConnectModal() {
      this.$stopInterval(this.vehicleWatcher);
      this.modalAlertCgwCecuNotCommunicated = false;
    },

    /**
     * 車両通信ポーリングの再開処理（全DTCの場合、OBFCM取得しない）
     */
    async getObfcmToVehicle() {
      const data = {
        this: this,
        netAppId: this.pairingAppId,
        requestBody: {
          type: constants.VEHICLE_CONTINUE_CHECK_SYSTEM_TYPE_GET_OBFCM,
          is_consent_obfcm: false
        }
      };
      // SystemsAPIのCGWサポートチェック後の処理を実行
      const isSuccess = await this.continueSystemApi(data);

      // 正常終了か確認
      if (isSuccess) {
        // 車両通信ポーリングを再開
        this.$resumeInterval(this.vehicleWatcher);
      }
      else {
        // ポーリングの停止
        this.$stopInterval(this.vehicleWatcher);
      }
    },

    /** 帳票印刷 ダイアログの初期化 */
    resetModalPrint() {
      this.isPrintFormatButtonDisable = true;
    },

    /** マイレージ設定ダイアログを開く */
    opensSettingMileage() {
      this.modalSettingMileageForm = true;
    },

    /** マイレージ設定ダイアログの初期化 */
    resetMileageModal() {
      this.inputMileage = '';
      // アラート情報をクリア
      this.clearInputAlert();
    },

    /** 入力画面アラートクリアイベント */
    clearInputAlert() {
      // アラート情報をクリア
      this.isAlert = {
        data: { valid: null, msg: '' }
      };
    },

    /** バリデーションチェック */
    validate() {
      this.isAlert.data = inputValidator.validateCommons(
        this.inputMileage, true, 6, /^[0-9]*$/
      );
      return this.isAlert.data.valid === null;
    },

    /** OKボタン押下 */
    settingMileageOk() {
      // アラート情報をクリア
      this.clearInputAlert();
      // 入力チェック
      if (!this.validate()) {
        return;
      }
      // 帳票印刷側の走行距離設定処理を呼び出し
      this.$refs.print_modal.setMileage(this.inputMileage);
      // 帳票印刷ボタンの非活性解除
      this.isPrintFormatButtonDisable = false;
      // マイレージ設定ダイアログを閉じる
      this.modalSettingMileageForm = false;
    },

    /* Start テスト用の関数一覧 */
    // DTCのテストデータ出力関数
    dtcTestDataExport() {
      // テストdataを生成する
      const test = { info: [] };
      this.allDtcSystems.data.forEach(element => {
        // DTCコードが設定されているもののみテスト用で出力する。 
        if (element.code) {
          const resouceId = this.removeResouceKey(resource.getDtcDescriptionResource(element, this));
          const testData = {
            system: element.system,
            reference: element.reference,
            code: element.code,
            unspecified_code: element.unspecified_code,
            resouce_id: resouceId
          };
          test.info.push(testData);
        }
      });
      if (test.info.length > 0) {
        const systemName = test.info[0].system;
        const blob = new Blob([JSON.stringify(test, null, '  ')], {
          type: 'application/json',
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = ('{0}_DTC_FRONT.json').format(systemName); // 出力するファイルの名前
        link.click();
        link.remove();
      }
    },

    // DIDのテストデータ出力関数
    didTestDataExport() {
      const ffd = this.$refs.ffd_modal.getTestData();
      const test = this.createFFDTestData(this.ffdSystemTable, ffd.items);
      // テストdataを生成する
      // 独自のsortIDでソート
      test.info.sort((a, b) => {
        if (a.sortId < b.sortId) return -1;
        if (a.sortId > b.sortId) return 1;
        return 0;
      });
      // データモニター表示順でソート
      test.info.sort((a, b) => {
        if (a.monitor_order < b.monitor_order) return -1;
        if (a.monitor_order > b.monitor_order) return 1;
        return 0;
      });
      // 独自のsortID削除
      test.info.forEach(element => {
        delete element.sortId;
      });

      if (test.info.length > 0) {
        const systemName = this.removeResouceKey(this.selectedSystem.name);
        const csvArray = [[], [], []];
        ffd.items.forEach(ffdData => {
          csvArray[0].push(this.$t(ffdData.item));
          csvArray[1].push(this.$t(ffdData.unit));
          csvArray[2].push(ffdData[0]);
        });

        let csvData = '';
        csvArray.forEach(a => {
          const row = a.join(',');
          csvData += row + '\r\n';
        });
        const bomFormatData = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM
        const csvBlob = new Blob([bomFormatData, csvData],
          {
            type: 'text/csv;charset=utf-8',
          });
        const csvLink = document.createElement('a');
        csvLink.href = URL.createObjectURL(csvBlob);
        csvLink.download = ('{0}_DID_FRONT.csv').format(systemName); // 出力するファイルの名前
        csvLink.click();
        csvLink.remove();

        const blob = new Blob([JSON.stringify(test, null, '  ')], {
          type: 'application/json',
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = ('{0}_DID_FRONT.json').format(systemName); // 出力するファイルの名前
        link.click();
        link.remove();
      }
    },

    createFFDTestData(originalData, tableData) {
      const result = { info: [] };

      // 取得したデータを ffd_save_order で振り分ける
      const groubBySystem = util.groupBy(originalData, 'ffd_save_order');
      // 優先して最新(確定)のデータのみ取得する。
      let currentData = null;
      if (util.isKeyExists(groubBySystem, '0')) {
        currentData = groubBySystem['0'];
      } else {
        currentData = groubBySystem['1'];
      }

      if (currentData) {
        tableData.forEach(element => {
          const keyId = this.removeResouceKey(element.item);
          const index = currentData.findIndex(item => item.id === keyId);
          if (index === -1) {
            logWrapper.log('ID not found in current data.', keyId);
          }
          else {
            let keyIndex = 0;
            // 10個のキー名までチェックする。            
            for (let index = 0; index < 10; index++) {
              keyIndex = String(index);
              if (util.isKeyExists(element, keyIndex)) {
                // keyが存在した場合は処理終了
                break;
              }
            }
            const valueKey = 'value_' + keyIndex;
            const resouceIdKey = 'resouceId_' + keyIndex;

            // テストデータは検出時のみを取得する。 
            const findData = currentData[index];

            let sortId = "";
            const keyUnderSplit = keyId.split('_');
            if (keyUnderSplit.length > 1) {
              const second = keyUnderSplit[1].padStart(2, '0');
              sortId = keyUnderSplit[0] + '_' + second;
            }
            if (keyUnderSplit.length > 2) {
              const covertNumber = Number(keyUnderSplit[2]);
              if (!isNaN(covertNumber)) {
                const therd = keyUnderSplit[2].padStart(covertNumber, '0');
                sortId = sortId + '_' + therd;
              }
            }

            const testData = {
              id: keyId,
              sortId: sortId,
              unit: this.removeResouceKey(element.unit),
              digits_after_decimal: findData.digits_after_decimal,
              data_type: findData.data_type,
              value: String(this.roundValue(element[valueKey])),
              value_resouce_id: this.removeResouceKey(element[resouceIdKey]),
              monitor_order: findData.monitor_order
            };
            result.info.push(testData);
          }
        });
      }
      return result;
    },

    removeResouceKey(resouceId) {
      let result = "";
      // 設定されていない場合は""文字列で戻す
      if (!resouceId) {
        return result;
      }
      const resouces = resouceId.split('.');
      if (resouces.length > 0) {
        result = resouces[1];
      }
      return result;
    },

    roundValue(value) {
      let result = value;
      if (value) {
        if ((typeof value) === "number") {
          result = value.toFixed(10);
        }
      }
      return result;
    }
    /* End テスト用の関数一覧 */
  },

  computed: {

    ...mapState({
      userInfo: state => state.userProperty.userInfo,
      userProperty: state => state.userProperty,
      allDtcSystems: state => state.table.allDtcSystems,
      vehicleInfo: state => state.vehicle.vehicleInfo,
      language: state => state.systems.language,
      // クラウドコネクターの接続状況
      pairingAppId: state => state.netAppConnector.pairingAppId,
      // 車種情報取得の接続状況
      vehicleStatus: state => state.vehicle.status,
      vehicleError: state => state.vehicle.error,
      vehicleWatcher: state => state.vehicle.watcher,
      progress: state => state.vehicle.progress,
      phase: state => state.vehicle.phase,
      // 車両のキャッシュ情報
      oldVehicleInfo: state => state.cache.vehicleInfo,
      breadCrumbs: state => state.app.breadCrumbs,
      deleteResultDtcs: state => state.vehicle.deleteResultDtcs,
      // メモリクリアの情報
      systemCount: state => state.vehicle.systemCount,
      cachedFFDs: state => state.cache.ffdStores,
      // 個別診断メニューの情報
      individualMenus: state => state.vehicle.individualMenus,
      isTestMode: state => state.netAppConnector.isTestMode,
      isIndividualDiagAvailable: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_INDIVIDUAL_DIAG],
      apiDestination: state => state.vehicle.apiDestination,
    }),
    // 診断系のAPIは複数画面から使用されているため
    // 現在の画面で使用されるAPIが診断/データ再生/個別診断のうちどの機能なのか判別する
    operationScreen() {
      return diagnoResource.operationFrom(this.$router.currentRoute.value.name);
    },

    checkButtonClass() {
      switch (this.$parent.$i18n.locale) {
        case "fr":
          return buttonFontSizeOther;
        default:
          return "";
      }
    },
    /** 計測データID */
    measureId() {
      return this.vehicleInfo.vehicle.project.all_dtc.measure_id;
    },
    /** 計測データ取得先サービス */
    destinationAPI() {
      return apiService.DIAG;
    },
    /** トレーニングモードでCSVのファイル名に使用するデータ名 */
    testModeMeasuredDataName() {
      return this.isTestMode ? this.memoData.dataName : '';
    }
  },

  created() {
    // DTCテーブルカラムの作成
    this.updateColumns();
  },

  mounted() {
    // Menu画面から個別診断メニューが選択されて遷移してきた時
    if (this.$route.query && Object.prototype.hasOwnProperty.call(this.$route.query, 'funcId') && Object.prototype.hasOwnProperty.call(this.$route.query, 'systemId')) {
      if (individualDiagnose.isRouteNameIndividualDiagnose(util.getPreviousDisplayName(this.$route))) {
        // 個別診断画面の初期化通信失敗エラーダイアログの OK を押されて戻ってきた場合は、メニュー画面に戻る必要がある
        this.$router.push({
          name: 'menu'
        });
        return;
      }

      // 個別診断の選択された機能に遷移する
      // 機能選択のボタンやツリーの選択状態の変更は、遷移先で実施する
      individualDiagnose.moveIndividualDiagnoseScreen(
        this,
        this.$route.query.funcId,
        this.$route.query.systemId,
        this.$route.query.sameSystemFlg,
      );
    } else {
      // イベントログのページビューカウント
      eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_ALL_DTC);
    }

    this.$emit('setVehicleTabsAvailable', true);
    this.cacheFFDStores([]);
    // 作成したDTCテーブルを設定
    this.updateDTCTable();

    // debug 環境のみ実施有効とする
    if (process.env.VUE_APP_DEBUG_LOG) {
      // テストボタン表示 
      document.onkeydown = (event) => {
        if (event) {
          // Ctrl+Shift+V key detection
          if (event.shiftKey && event.ctrlKey) {
            if (event.code === "KeyV") {
              this.testModeVisible = true;
              return true;
            }
          }
        }
        return util.checkSSM5ValidCharacters(event);
      };
    }
  },

  beforeUnmount() {
    this.$stopInterval(this.vehicleWatcher);

    // debug 環境のみ実施有効とする
    if (process.env.VUE_APP_DEBUG_LOG) {
      // onkeydown の再登録
      document.onkeydown = (event) => {
        return util.checkSSM5ValidCharacters(event);
      };
    }
  },
};
